function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { Children } from "../util/Children";
import { Percent } from "../util/Percent";
import { Sprite } from "./Sprite";
import { Rectangle } from "./Rectangle";
import { HorizontalLayout } from "./HorizontalLayout";
import { VerticalLayout } from "./VerticalLayout";
import { GridLayout } from "./GridLayout";
import { populateString } from "../util/PopulateString";
import * as $array from "../util/Array";
import * as $type from "../util/Type";
import * as $utils from "../util/Utils";
/**
 * A basic element that can have child elements, maintain their layout, and
 * have a background.
 *
 * It can have any [[Sprite]] element as a child, from very basic shapes, to
 * full-fledged charts.
 *
 * @see {@link https://www.amcharts.com/docs/v5/concepts/common-elements/containers/} for more info
 * @important
 */
export var Container = /*#__PURE__*/function (_Sprite) {
  _inherits(Container, _Sprite);
  var _super = _createSuper(Container);
  function Container() {
    var _this;
    _classCallCheck(this, Container);
    _this = _super.apply(this, arguments);
    Object.defineProperty(_assertThisInitialized(_this), "_display", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this._root._renderer.makeContainer()
    });
    Object.defineProperty(_assertThisInitialized(_this), "_childrenDisplay", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: _this._root._renderer.makeContainer()
    });
    /**
     * List of Container's child elements.
     */
    Object.defineProperty(_assertThisInitialized(_this), "children", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new Children(_assertThisInitialized(_this))
    });
    Object.defineProperty(_assertThisInitialized(_this), "_percentageSizeChildren", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(_assertThisInitialized(_this), "_percentagePositionChildren", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(_assertThisInitialized(_this), "_prevWidth", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_prevHeight", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_contentWidth", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_contentHeight", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_contentMask", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_vsbd0", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_vsbd1", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    return _this;
  }
  _createClass(Container, [{
    key: "_afterNew",
    value: function _afterNew() {
      _get(_getPrototypeOf(Container.prototype), "_afterNew", this).call(this);
      this._display.addChild(this._childrenDisplay);
    }
  }, {
    key: "_dispose",
    value: function _dispose() {
      $array.eachReverse(this.allChildren(), function (child) {
        child.dispose();
      });
      if (this.getPrivate("htmlElement")) {
        this._root._removeHTMLContent(this);
      }
      _get(_getPrototypeOf(Container.prototype), "_dispose", this).call(this);
    }
  }, {
    key: "_changed",
    value: function _changed() {
      _get(_getPrototypeOf(Container.prototype), "_changed", this).call(this);
      if (this.isDirty("interactiveChildren")) {
        this._display.interactiveChildren = this.get("interactiveChildren", false);
      }
      if (this.isDirty("layout")) {
        this._prevWidth = 0;
        this._prevHeight = 0;
        this.markDirtyBounds();
        if (this._prevSettings.layout) {
          this.children.each(function (child) {
            child.removePrivate("x");
            child.removePrivate("y");
          });
        }
      }
      if (this.isDirty("paddingTop") || this.isDirty("paddingBottom") || this.isDirty("paddingLeft") || this.isDirty("paddingRight")) {
        this.children.each(function (child) {
          child.markDirtyPosition();
        });
      }
      if (this.isDirty("maskContent")) {
        var childrenDisplay = this._childrenDisplay;
        var contentMask = this._contentMask;
        if (this.get("maskContent")) {
          if (!contentMask) {
            contentMask = Rectangle.new(this._root, {
              x: -.5,
              y: -.5,
              width: this.width() + 1,
              height: this.height() + 1
            });
            this._contentMask = contentMask;
            childrenDisplay.addChildAt(contentMask._display, 0);
            childrenDisplay.mask = contentMask._display;
          }
        } else {
          if (contentMask) {
            childrenDisplay.removeChild(contentMask._display);
            childrenDisplay.mask = null;
            contentMask.dispose();
            this._contentMask = undefined;
          }
        }
      }
    }
  }, {
    key: "_updateSize",
    value: function _updateSize() {
      _get(_getPrototypeOf(Container.prototype), "_updateSize", this).call(this);
      $array.each(this._percentageSizeChildren, function (child) {
        child._updateSize();
      });
      $array.each(this._percentagePositionChildren, function (child) {
        child.markDirtyPosition();
        child._updateSize();
      });
      this.updateBackground();
    }
  }, {
    key: "updateBackground",
    value: function updateBackground() {
      var background = this.get("background");
      var bounds = this._localBounds;
      if (bounds && !this.isHidden()) {
        var x = bounds.left;
        var y = bounds.top;
        var w = bounds.right - x;
        var h = bounds.bottom - y;
        var maxWidth = this.get("maxWidth");
        var maxHeight = this.get("maxHeight");
        if (maxHeight) {
          if (h > maxHeight) {
            h = maxHeight;
          }
        }
        if (maxWidth) {
          if (w > maxWidth) {
            w = maxWidth;
          }
        }
        var width = this.width();
        var height = this.height();
        if (background) {
          background.setAll({
            width: w,
            height: h,
            x: x,
            y: y
          });
          if (this._display.interactive) {
            background._display.interactive = true;
          }
        }
        var contentMask = this._contentMask;
        if (contentMask) {
          contentMask.setAll({
            width: width + 1,
            height: height + 1
          });
        }
        var verticalScrollbar = this.get("verticalScrollbar");
        if (verticalScrollbar) {
          verticalScrollbar.set("height", height);
          verticalScrollbar.set("x", width - verticalScrollbar.width() - verticalScrollbar.get("marginRight", 0));
          verticalScrollbar.set("end", verticalScrollbar.get("start", 0) + height / this._contentHeight);
          var bg = verticalScrollbar.get("background");
          if (bg) {
            bg.setAll({
              width: verticalScrollbar.width(),
              height: height
            });
          }
          var visible = true;
          if (this._contentHeight <= height) {
            visible = false;
          }
          verticalScrollbar.setPrivate("visible", visible);
        }
      }
    }
  }, {
    key: "_applyThemes",
    value: function _applyThemes() {
      if (_get(_getPrototypeOf(Container.prototype), "_applyThemes", this).call(this)) {
        this.eachChildren(function (child) {
          child._applyThemes();
        });
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "_applyState",
    value: function _applyState(name) {
      _get(_getPrototypeOf(Container.prototype), "_applyState", this).call(this, name);
      if (this.get("setStateOnChildren")) {
        this.eachChildren(function (child) {
          child.states.apply(name);
        });
      }
    }
  }, {
    key: "_applyStateAnimated",
    value: function _applyStateAnimated(name, duration) {
      _get(_getPrototypeOf(Container.prototype), "_applyStateAnimated", this).call(this, name, duration);
      if (this.get("setStateOnChildren")) {
        this.eachChildren(function (child) {
          child.states.applyAnimate(name, duration);
        });
      }
    }
    /**
     * Returns container's inner width (width without padding) in pixels.
     *
     * @return Inner width (px)
     */
  }, {
    key: "innerWidth",
    value: function innerWidth() {
      return this.width() - this.get("paddingRight", 0) - this.get("paddingLeft", 0);
    }
    /**
     * Returns container's inner height (height without padding) in pixels.
     *
     * @return Inner height (px)
     */
  }, {
    key: "innerHeight",
    value: function innerHeight() {
      return this.height() - this.get("paddingTop", 0) - this.get("paddingBottom", 0);
    }
  }, {
    key: "_getBounds",
    value: function _getBounds() {
      var width = this.get("width");
      var height = this.get("height");
      var pWidth = this.getPrivate("width");
      var pHeight = this.getPrivate("height");
      var bounds = {
        left: 0,
        top: 0,
        right: this.width(),
        bottom: this.height()
      };
      var layout = this.get("layout");
      var horizontal = false;
      var vertical = false;
      if (layout instanceof HorizontalLayout || layout instanceof GridLayout) {
        horizontal = true;
      }
      if (layout instanceof VerticalLayout) {
        vertical = true;
      }
      if ((width != null || pWidth != null) && (height != null || pHeight != null) && !this.get("verticalScrollbar")) {
        // void
      } else {
        var m = Number.MAX_VALUE;
        var l = m;
        var r = -m;
        var t = m;
        var b = -m;
        var paddingLeft = this.get("paddingLeft", 0);
        var paddingTop = this.get("paddingTop", 0);
        var paddingRight = this.get("paddingRight", 0);
        var paddingBottom = this.get("paddingBottom", 0);
        this.children.each(function (child) {
          if (child.get("position") != "absolute" && child.get("isMeasured")) {
            var childBounds = child.adjustedLocalBounds();
            var childX = child.x();
            var childY = child.y();
            var cl = childX + childBounds.left;
            var cr = childX + childBounds.right;
            var ct = childY + childBounds.top;
            var cb = childY + childBounds.bottom;
            if (horizontal) {
              cl -= child.get("marginLeft", 0);
              cr += child.get("marginRight", 0);
            }
            if (vertical) {
              ct -= child.get("marginTop", 0);
              cb += child.get("marginBottom", 0);
            }
            if (cl < l) {
              l = cl;
            }
            if (cr > r) {
              r = cr;
            }
            if (ct < t) {
              t = ct;
            }
            if (cb > b) {
              b = cb;
            }
          }
        });
        if (l == m) {
          l = 0;
        }
        if (r == -m) {
          r = 0;
        }
        if (t == m) {
          t = 0;
        }
        if (b == -m) {
          b = 0;
        }
        bounds.left = l - paddingLeft;
        bounds.top = t - paddingTop;
        bounds.right = r + paddingRight;
        bounds.bottom = b + paddingBottom;
      }
      this._contentWidth = bounds.right - bounds.left;
      this._contentHeight = bounds.bottom - bounds.top;
      if ($type.isNumber(width)) {
        bounds.left = 0;
        bounds.right = width;
      }
      if ($type.isNumber(pWidth)) {
        bounds.left = 0;
        bounds.right = pWidth;
      }
      if ($type.isNumber(height)) {
        bounds.top = 0;
        bounds.bottom = height;
      }
      if ($type.isNumber(pHeight)) {
        bounds.top = 0;
        bounds.bottom = pHeight;
      }
      this._localBounds = bounds;
    }
  }, {
    key: "_updateBounds",
    value: function _updateBounds() {
      var layout = this.get("layout");
      if (layout) {
        layout.updateContainer(this);
      }
      _get(_getPrototypeOf(Container.prototype), "_updateBounds", this).call(this);
      this.updateBackground();
    }
    /**
     * @ignore
     */
  }, {
    key: "markDirty",
    value: function markDirty() {
      _get(_getPrototypeOf(Container.prototype), "markDirty", this).call(this);
      this._root._addDirtyParent(this);
    }
  }, {
    key: "_prepareChildren",
    value: function _prepareChildren() {
      var innerWidth = this.innerWidth();
      var innerHeight = this.innerHeight();
      if (innerWidth != this._prevWidth || innerHeight != this._prevHeight) {
        var layout = this.get("layout");
        var horizontal = false;
        var vertical = false;
        if (layout) {
          if (layout instanceof HorizontalLayout || layout instanceof GridLayout) {
            horizontal = true;
          }
          if (layout instanceof VerticalLayout) {
            vertical = true;
          }
        }
        $array.each(this._percentageSizeChildren, function (child) {
          if (!horizontal) {
            var width = child.get("width");
            if (width instanceof Percent) {
              child.setPrivate("width", width.value * innerWidth);
            }
          }
          if (!vertical) {
            var height = child.get("height");
            if (height instanceof Percent) {
              child.setPrivate("height", height.value * innerHeight);
            }
          }
        });
        $array.each(this._percentagePositionChildren, function (child) {
          child.markDirtyPosition();
          child.markDirtyBounds();
        });
        this._prevWidth = innerWidth;
        this._prevHeight = innerHeight;
        this._sizeDirty = true;
        this.updateBackground();
      }
      this._handleStates();
    }
  }, {
    key: "_updateChildren",
    value: function _updateChildren() {
      var _this2 = this;
      if (this.isDirty("html")) {
        var html = this.get("html");
        if (html && html !== "") {
          this._root._setHTMLContent(this, populateString(this, this.get("html", "")));
        } else {
          this._root._removeHTMLContent(this);
        }
        this._root._positionHTMLElement(this);
      }
      if (this.isDirty("verticalScrollbar")) {
        var verticalScrollbar = this.get("verticalScrollbar");
        if (verticalScrollbar) {
          verticalScrollbar._setParent(this);
          verticalScrollbar.children.removeValue(verticalScrollbar.startGrip);
          verticalScrollbar.children.removeValue(verticalScrollbar.endGrip);
          this.set("maskContent", true);
          this.set("paddingRight", verticalScrollbar.width() + verticalScrollbar.get("marginRight", 0) + verticalScrollbar.get("marginLeft", 0));
          var background = this.get("background");
          if (!background) {
            background = this.set("background", Rectangle.new(this._root, {
              themeTags: ["background"],
              fillOpacity: 0,
              fill: this._root.interfaceColors.get("alternativeBackground")
            }));
          }
          this._vsbd0 = this.events.on("wheel", function (event) {
            var wheelEvent = event.originalEvent;
            // Ignore wheel event if it is happening on a non-chart element, e.g. if
            // some page element is over the chart.
            if ($utils.isLocalEvent(wheelEvent, _this2)) {
              wheelEvent.preventDefault();
            } else {
              return;
            }
            var shiftY = wheelEvent.deltaY / 5000;
            var start = verticalScrollbar.get("start", 0);
            var end = verticalScrollbar.get("end", 1);
            if (start + shiftY <= 0) {
              shiftY = -start;
            }
            if (end + shiftY >= 1) {
              shiftY = 1 - end;
            }
            if (start + shiftY >= 0 && end + shiftY <= 1) {
              verticalScrollbar.set("start", start + shiftY);
              verticalScrollbar.set("end", end + shiftY);
            }
          });
          this._disposers.push(this._vsbd0);
          this._vsbd1 = verticalScrollbar.events.on("rangechanged", function () {
            var h = _this2._contentHeight;
            var childrenDisplay = _this2._childrenDisplay;
            var contentMask = _this2._contentMask;
            childrenDisplay.y = -verticalScrollbar.get("start") * h;
            childrenDisplay.markDirtyLayer();
            if (contentMask) {
              contentMask._display.y = -childrenDisplay.y;
              childrenDisplay.mask = contentMask._display;
            }
          });
          this._disposers.push(this._vsbd1);
          this._display.addChild(verticalScrollbar._display);
        } else {
          var previous = this._prevSettings.verticalScrollbar;
          if (previous) {
            this._display.removeChild(previous._display);
            if (this._vsbd0) {
              this._vsbd0.dispose();
            }
            if (this._vsbd1) {
              this._vsbd1.dispose();
            }
            var childrenDisplay = this._childrenDisplay;
            childrenDisplay.y = 0;
            this.setPrivate("height", undefined);
            this.set("maskContent", false);
            this.set("paddingRight", undefined);
          }
        }
      }
      if (this.isDirty("background")) {
        // TODO maybe this should dispose ?
        var _previous = this._prevSettings["background"];
        if (_previous) {
          this._display.removeChild(_previous._display);
        }
        var _background = this.get("background");
        if (_background instanceof Sprite) {
          _background.set("isMeasured", false);
          _background._setParent(this);
          this._display.addChildAt(_background._display, 0);
        }
      }
      if (this.isDirty("mask")) {
        var mask = this.get("mask");
        var _previous2 = this._prevSettings["mask"];
        if (_previous2) {
          this._display.removeChild(_previous2._display);
          if (_previous2 != mask) {
            _previous2.dispose();
          }
        }
        if (mask) {
          var parent = mask.parent;
          if (parent) {
            parent.children.removeValue(mask);
          }
          mask._setParent(this);
          this._display.addChildAt(mask._display, 0);
          this._childrenDisplay.mask = mask._display;
        }
      }
    }
  }, {
    key: "_processTemplateField",
    value: function _processTemplateField() {
      _get(_getPrototypeOf(Container.prototype), "_processTemplateField", this).call(this);
      this.children.each(function (child) {
        child._processTemplateField();
      });
    }
    /**
     * @ignore
     */
  }, {
    key: "walkChildren",
    value: function walkChildren(f) {
      this.children.each(function (child) {
        if (child instanceof Container) {
          child.walkChildren(f);
        }
        f(child);
      });
    }
  }, {
    key: "eachChildren",
    value: function eachChildren(f) {
      var background = this.get("background");
      if (background) {
        f(background);
      }
      var verticalScrollbar = this.get("verticalScrollbar");
      if (verticalScrollbar) {
        f(verticalScrollbar);
      }
      var mask = this.get("mask");
      if (mask) {
        f(mask);
      }
      this.children.values.forEach(function (child) {
        f(child);
      });
    }
  }, {
    key: "allChildren",
    value: function allChildren() {
      var output = [];
      this.eachChildren(function (x) {
        output.push(x);
      });
      return output;
    }
  }, {
    key: "_setDataItem",
    value: function _setDataItem(dataItem) {
      var updated = dataItem !== this._dataItem;
      _get(_getPrototypeOf(Container.prototype), "_setDataItem", this).call(this, dataItem);
      var html = this.get("html", "");
      if (html && html !== "" && updated) {
        this._root._setHTMLContent(this, populateString(this, html));
      }
    }
  }]);
  return Container;
}(Sprite);
Object.defineProperty(Container, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Container"
});
Object.defineProperty(Container, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Sprite.classNames.concat([Container.className])
});